export const ACTION = {
    GET_ALL_FUNDS_PRODUCT_LIST: 'GET_ALL_FUNDS_PRODUCT_LIST',
    GET_ALL_FUNDS_PRODUCT_FILTERS: 'GET_ALL_FUNDS_PRODUCT_FILTERS',
    GET_SINGLE_FUND_DETAILS: 'GET_SINGLE_FUND_DETAILS',
    GET_SINGLE_FUND_NAV: 'GET_SINGLE_FUND_NAV',
    GET_NFO_LIST: 'GET_NFO_LIST',
    POST_COMPARE_LIST: 'POST_COMPARE_LIST',
    POST_COMPARE_LIST_DUBLICATE: 'POST_COMPARE_LIST_DUBLICATE',
    POST_COMPARE_FUNDS: 'POST_COMPARE_FUNDS',
    POST_NAV_OVERVIEW: 'POST_NAV_OVERVIEW',
    GET_NFO_OVERVIEW: 'GET_NFO_OVERVIEW',
    GET_INDEX_FUND_LIST: 'GET_INDEX_FUND_LIST',
    INDEX_SUBSCRIBE: 'INDEX_SUBSCRIBE',
    //etf apis
    GET_ETF: 'GET_ETF',
    GET_ETF_FUNDS: 'GET_ETF_FUNDS',
    GET_ETF_FUNDS_LIST: 'GET_ETF_FUNDS_LIST',
    POST_ETF_SUBSCRIBE: 'POST_ETF_SUBSCRIBE',
    GET_SCHEME_CONTENT_SCHEME: 'GET_SCHEME_CONTENT_SCHEME',
    POST_SUBSCRIBE_PRODUCT: 'POST_SUBSCRIBE_PRODUCT',
    CLEAR_SUBSCRIBE_RESULT: 'CLEAR_SUBSCRIBE_RESULT',
    CLEAN_INDEX_FUND_CONTENT: 'CLEAN_INDEX_FUND_CONTENT',
    SMALL_CASE_TOKEN_HIDE: 'SMALL_CASE_TOKEN_HIDE',
    // investment basket
    GET_GOALS_CONTENT: 'GET_GOALS_CONTENT',
    GET_GOAL_QUESTION: 'GET_GOAL_QUESTION',
    VERIFY_PAN: 'VERIFY_PAN',
    VERIFY_KYC: 'VERIFY_KYC',
    CLEAN_GOALS_CONTENT: 'CLEAN_GOALS_CONTENT',
    GET_GOAL_SUGGESTION: 'GET_GOAL_SUGGESTION',
    GET_RISK_QUESTION_ANS: 'GET_RISK_QUESTION_ANS',
    EVALUATE_RISK_APPETITE: 'EVALUATE_RISK_APPETITE',
    GET_BASKET_RECOMMENDATION: 'GET_BASKET_RECOMMENDATION',
    GET_RISK_APPETITES_LIST: 'GET_RISK_APPETITES_LIST',
    CLEAN_RISK_CONTENT: 'CLEAN_RISK_CONTENT',
    CLEAN_GOALS_QUESTIONS: 'CLEAN_GOALS_QUESTIONS',
    PRIV_KEY: "MIICeAIBADANBgkqhkiG9w0BAQEFAASCAmIwggJeAgEAAoGBAKX8ucv6DDtzTUO3NWYnFvyavpvhVNCGwQ8tZFXgtpRmvGieo/fD5oq7F8u0uldJDvERNDJbZV5r7xmvsb0ZuzOC7Bp9XGPSDRtd7CF0K8oz83YWMlrt30pBpBGtfGBWyoGO7H/HFpqhryCiQMKJdfWw0m3+oHPAuSdbq8F0SjXDAgMBAAECgYEAkkrw8i8a0tbnlTQG81amctJsBnUNzI/H3fmSwgHAyYDWs5qGR1u4eDM3YMmTplR0v9D64Rsed57HaCsqitD/5JFZKbVESIIn0St06Scw537+eK1z8rLL4tNY3wG931ekY27fEupqAjoRr6G2jWc24bIwCLgCbvL44NP759qCuOkCQQDyt8V3eUMrwMhvII0Jc6lXi3zz7Yv4sdiUjhV2ZPj8zfrPJxfknF0crHmrl4l9kGN53dtPL3wNm4K/Rrp4KAKvAkEArxIJX/AR9JSB5eiaQyZMIIyVWvX7z68lOf7e11wK58hLU870EYYsSZKLbyr2P1+zh7aK1yN24nSR329ivo1TLQJACEM3RqzrG3cxm47ZHkRAtIk8FLW2eR3cyJnZozEmxLxiWGD1UEP+a3Z3od7DwHGE4WYrDBQKvg/YMJjAykxaYwJBAJEagvioc0ljmXKkYs+LO4ey3cvhm8+cXF+AVtTq7gMEaSLSokqwCZ8FPlpqomUOfi/a5aLBOzUg5xLpME+9tRUCQQDAsgApPlR0w9IfWYZ82rfc0w7uqfUIi9ZDfJSKF7X+cTLWNQXQVcisb7nA6JN6jd8ES+DmU8u5nfmcJ3RELZMT",
    PASS_PUB_KEY: 'MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCl/LnL+gw7c01DtzVmJxb8mr6b4VTQhsEPLWRV4LaUZrxonqP3w+aKuxfLtLpXSQ7xETQyW2Vea+8Zr7G9GbszguwafVxj0g0bXewhdCvKM/N2FjJa7d9KQaQRrXxgVsqBjux/xxaaoa8gokDCiXX1sNJt/qBzwLknW6vBdEo1wwIDAQAB',
    JOURNEY: {
        RISK_PROFILER: "RISK_JOURNEY",
        INVESTMENT_BASKET_JOURNEY: "INVESTMENT_BASKET_JOURNEY",
        GOAL_JOURNEY: "GOAL_JOURNEY",
    },
    VERIFY_OTP: 'VERIFY_OTP',
    SAVE_PRE_LOGIN_DATA: 'SAVE_PRE_LOGIN_DATA',
    VALIDATE_BASKET_SCHEMES: 'VALIDATE_BASKET_SCHEMES',
    RESEND_OTP: 'RESEND_OTP',
    GET_ALL_BASKETS: 'GET_ALL_BASKETS',
    BASKET_META:'BASKET_META',
    FORCE_LOGOUT: 'FORCE_LOGOUT',
    CLEAN_AUTH_CONTENT: 'CLEAN_AUTH_CONTENT',
    POST_LINE_GRAPH: 'POST_LINE_GRAPH',
};

// investment basket
export const JOURNEYPAGE_TYPE = {
    RISK_LANDING: 0,
    RISK_QUESTIONNAIRE: 1,
    RISK_AUTH: 2,
    RISK_KYC: 3,
    RISK_RECOMMENDATION: 4,

};